// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1__f002ff7bb2ca85939568","cls2":"AccountMenuButton-cls2__ad117d71e8009d527185 AccountMenuButton-cls1__f002ff7bb2ca85939568"};